import AboutIcon from './About';
import BinIcon from './Bin';
import CogIcon from './Cog';
import ConnectIcon from './Connect';
import DatabaseIcon from './Database';
import GithubIcon from './Github';
import KeyIcon from './Key';
import Logo from './Logo';
import WebsiteIcon from './Website';

export { AboutIcon, BinIcon, ConnectIcon, CogIcon, DatabaseIcon, GithubIcon, KeyIcon, Logo, WebsiteIcon };



// WEBPACK FOOTER //
// ./src/options/icons/index.js